import ModalContext from 'contexts/ModalContext'
import { useCallback, useContext } from 'react'
import type { PlaceImageWithId } from 'tripPlanner/utils/placeImages'
import PlaceInfoGalleryLightbox from '../components/PlaceInfoGalleryLightbox'

interface UsePlaceInfoGalleryLightboxArgs {
  googlePlaceId: string
  isOpen: boolean
  images: Array<PlaceImageWithId>
}

export function usePlaceInfoGalleryLightbox({
  googlePlaceId,
  isOpen,
  images,
}: UsePlaceInfoGalleryLightboxArgs) {
  const showModal = useContext(ModalContext)

  const openGalleryLightboxAtIndex = useCallback((defaultIndex: number) => {
    if (!isOpen || images.length === 0) return

    showModal(<PlaceInfoGalleryLightbox
      googlePlaceId={googlePlaceId}
      images={images}
      defaultIndex={defaultIndex}
    />)
  }, [googlePlaceId, images, isOpen, showModal])

  return {
    openGalleryLightboxAtIndex,
  }
}
